export class CodedEntity {
  _id?      : string;
  code?     : string;
  name?     : string;
  startDate?: Date;
  endDate?  : Date;
}